export default "__VITE_ASSET__29c07632__"